import { z } from 'zod';
import { defineContract } from './contract';

/**
 * The product's public social accounts (module `social-links`, web-presence §2: they feed the
 * Organization `sameAs`). STRICT: exactly these three fields. A field the server adds by mistake
 * (id, position, timestamps) fails the contract test. Only visible links are listed, in order.
 */
export const SOCIAL_NETWORKS = [
  'facebook',
  'instagram',
  'x',
  'linkedin',
  'tiktok',
  'youtube',
  'whatsapp',
  'telegram',
  'snapchat',
  'threads',
  'other',
] as const;
export type SocialNetwork = (typeof SOCIAL_NETWORKS)[number];

export const publicSocialLinkSchema = z.strictObject({
  network: z.enum(SOCIAL_NETWORKS),
  url: z.url(),
  label: z.string().nullable(),
});
export type PublicSocialLink = z.infer<typeof publicSocialLinkSchema>;

export const publicSocialLinksSchema = z.strictObject({
  data: z.array(publicSocialLinkSchema),
});
export type PublicSocialLinks = z.infer<typeof publicSocialLinksSchema>;

export const socialLinksContracts = {
  list: defineContract({
    method: 'GET',
    path: '/public/social-links',
    response: publicSocialLinksSchema,
  }),
};
